import React from 'react';
import * as loadingStyle1 from './style1.json';
import * as loadingStyle2 from './style2.json';
// import * as loadingLine from "./styleLine.json";
import * as maintenance from './Maintenance.json';
import * as pageNotFound from './PageNotFound.json';
import * as welcome from './Welcome.json';
import FadeIn from 'react-fade-in';
import Lottie from 'react-lottie';

const Loading = ({ styles }) => {
   const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData:
         styles === 'dashboard'
            ? loadingStyle2.default
            : styles === 'maintenance'
            ? maintenance.default
            : styles === 'pageNotFound'
            ? pageNotFound.default
            : styles === 'welcome'
            ? welcome.default
            : loadingStyle1.default,
      rendererSettings: {
         preserveAspectRatio: 'xMidYMid slice',
      },
   };

   return (
      <React.Fragment>
         <FadeIn>
            <Lottie
               options={defaultOptions}
               height={styles === 'welcome' ? 300 : 140}
               width={styles === 'welcome' ? 300 : 140}
            />
         </FadeIn>
      </React.Fragment>
   );
};
export default Loading;
